/**
 * Helpers for working with linked data prop-types.
 *
 * These validate props for conforming to the rdfjs task force representation in plain object form.
 */

import { TermType } from "@ontologies/core";
import * as PropTypes from "prop-types";

/** Validate if the prop is a valid BlankNode. */
export const blankNodeShape = PropTypes.shape({
  termType: PropTypes.oneOf([TermType.BlankNode]).isRequired,
  value: PropTypes.string.isRequired,
});

/** Validate if the prop is a valid NamedNode. */
export const namedNodeShape = PropTypes.shape({
  termType: PropTypes.oneOf([TermType.NamedNode]).isRequired,
  value: PropTypes.string.isRequired,
});

/** Validate if the prop is a valid Literal. */
export const literalShape = PropTypes.shape({
  termType: PropTypes.oneOf([TermType.Literal]).isRequired,
  value: PropTypes.string.isRequired,

  datatype: namedNodeShape,
  language: PropTypes.string.isRequired,
});

/** Validate if the prop is a valid node (blank or named). */
export const nodeType = PropTypes.oneOfType([blankNodeShape, namedNodeShape]);

/** Validate if the prop is a valid term (blank node, named node, or literal). */
export const termType = PropTypes.oneOfType([blankNodeShape, namedNodeShape, literalShape]);

/** Validate if the prop is a valid Quad. */
export const quadShape = PropTypes.shape({
  subject: PropTypes.oneOfType([ blankNodeShape, namedNodeShape ]).isRequired,

  predicate: namedNodeShape.isRequired,

  object: PropTypes.oneOfType([ blankNodeShape, namedNodeShape, literalShape ]).isRequired,

  graph: PropTypes.oneOfType([ blankNodeShape, namedNodeShape ]),
});
